<template>
  <div id="protocol" >
    <div class="title" >
      <p >{{details.name}}</p>
    </div>
    <div class="main" >
      <p v-html="details.content"></p>
    </div>
    <div class="footer" >
      <van-checkbox class="checkbox" checked-color="#185494" v-model="checked" >我已阅读并同意协议</van-checkbox>
      <van-button :class="{ active: checked }" class="submit-btn" size="large" @click="routerPush()" >继续</van-button>
    </div>
    <div style="width: 100%; height: 30px;" ></div>
  </div>
</template>

<script>

import Vue from 'vue'
import { getValidMembership, mapMemberType } from '@/utils'
import { Checkbox, CheckboxGroup, Button, Toast } from 'vant'
import { checkPassport } from '@/libs/passport'
import { getMemberType, setMemberType } from '@/libs/cookie-storage'
import { getAgreementById } from '@/api/info'

Vue.use(Checkbox).use(CheckboxGroup).use(Button).use(Toast)

export default {
  name: 'Protocol',
  data() {
    return {
      checked: false,
      pId: null,
      typeId: '',
      memberType: null,
      details: {},
      reset: ''
    }
  },
  created() {
    checkPassport()
    this.pId = parseInt(this.$route.query.id)
    this.typeId = parseInt(this.$route.query.type)
    this.memberType = getMemberType() || {}
    if (!this.memberType.type) {
      const validMemberShip = getValidMembership()
      const memberShips = validMemberShip.membership
      if (memberShips.length > 0) {
        const member = mapMemberType(memberShips[0].membershipTypeId)
        this.memberType = _.assign(memberShips[0], member) // 字段合并
        setMemberType(this.memberType)
      }
    }
    this.getAgreementById()
    this.reset = parseInt(this.$route.query.reset)
  },
  methods: {
    routerPush() {
      if (!this.checked) {
        Toast({
          duration: 1000,
          message: '请先阅读并勾选协议'
        })
        return
      }
      let pathName = ''
      if (this.pId === 1) {
        pathName = 'status'
      } else if (this.pId === 2) {
        pathName = 'info'
        if (this.reset === 1) {
          this.$router.push({ path: pathName, query: {reset: 1} })
          return
        }
      } else if (this.pId === 3) {
        pathName = 'order'
        this.$router.push({ path: pathName, query: {type: this.typeId}})
        return
      }
      this.$router.push(pathName)
    },
    routerGo() {
      this.$router.go(-1)
    },
    getAgreementById() {
      let agreementId = -1
      if (this.pId === 1) {
        agreementId = '1114145380242784256'
      } else if (this.pId === 2) {
        if (this.memberType.type.indexOf('referee')>0) {
          agreementId = '1118759433250516992'
        } else {
          agreementId = '1118343395232968704'
        }
      } else if (this.pId === 3) {
        agreementId = '1114145468876824576'
      }
      getAgreementById(agreementId).then(response => {
        this.details = response.data
      })
    }
  }
}
</script>

<style>

  #protocol {
    position: relative;
    height: 100%;
  }

  #protocol .title {
    text-align: center;
    line-height: 1.3;
  }

  #protocol .title p {
    font-weight:500;
    color:rgba(74,74,74,1);
    font-size:20px;
  }

  #protocol .title p+span {
    font-size: 16px;
  }

  #protocol .main {
    padding: 0 15px;
    font-size: 12px; /*no*/
    line-height: 1.3;
    position: absolute;
    height: calc(100% - 200PX);
    width: calc(100% - 30PX);
    overflow: scroll;
  }

  #protocol .main p {
    text-indent: 20px;
    color: rgba(74,74,74,1);
    font-size: 14px;
  }

  #protocol .footer {
    background-color: white;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 5px;
  }

  #protocol .checkbox {
    font-size: 16px; /*no*/
    margin: auto;
  }

  #protocol .checkbox span {
    margin-left: 5px;
    font-weight: bolder;
  }

  /*
  #protocol .checkbox i {
    border: 1px solid #000;
  }
  */

  #protocol .submit-btn {
    margin-top: 10px;
    height:60px;
    background:rgba(245,245,245,1);
    border-radius:2px;
    border: none;
    width: 100%;
    left: 50%;
    transform: translate(-50%, 0);
    font-size:20px;
    font-weight:400;
    color:rgba(129,129,129,1);
  }

  #protocol .router-go {
    font-size: 16px; /*no*/
    text-align: center;
    line-height: 2;
  }

  #protocol .footer .checkbox .van-checkbox__icon {
    display: block;
    text-align: center;
    margin-bottom: 5px;
  }

  #protocol .footer .checkbox .van-checkbox__icon+span {
    color: #4A4A4A;
    font-size: 14px;
  }

  #protocol .active {
    background: #185494;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/identity-protocol.vue